import {gql} from '@apollo/client';

const mutationUpdateMfa = gql`
    mutation udpateMfa($user_id: String!, $mfa: Boolean!) {
        udpateMfa(user_id: $user_id, mfa: $mfa) {
        status
        message
        data
        }
    }
`;

const mutationUploadProfilePicture = gql`
  mutation uploadProfilePicture($userid: String!, $fileInput: Upload!) {
    uploadProfilePicture(userid: $userid, fileInput: $fileInput) {
      status
      message
      data
    }
  }
`;

const mutationAcceptDocument = gql`
    mutation acceptDocument ($user_id: Float!,$document_name: String!,$revision: String!, $schemaname:String! ) {
        acceptDocument(user_id: $user_id, document_name:$document_name, revision:$revision, schemaname:$schemaname) {
        status
        }
    }
`;

const mutationUpdateUserMetrics = gql`
    mutation updateUserMetrics($metrics_type: String!, $user_id: String!, $metrics_value: String ) {
        updateUserMetrics(metrics_type: $metrics_type, user_id: $user_id, metrics_value: $metrics_value) {
        status
        message
        }
    }
`;

const mutationEditProfile = gql`
    mutation editProfile ($user_id: String!, $firstname: String!, $middlename: String! ,$lastname: String!, $mobilenumber:String, $cognito_username: String, $mfa_enable:Boolean) {
        editProfile(user_id: $user_id, firstname: $firstname, middlename:$middlename,lastname:$lastname, mobilenumber:$mobilenumber, cognito_username:$cognito_username, mfa_enable:$mfa_enable) {
        status
        }
    }
`;

const mutationUpdatePreference = gql`
    mutation updatePreference(
        $preference_information: String,
        $preference_value: Boolean!,
        $preference_type: String,
        $preference_name: String,
        $user_id: String,
        $preference_id: String,
    ) {
        updatePreference(
            preference_information: $preference_information,
            preference_value: $preference_value,
            preference_type: $preference_type,
            preference_name: $preference_name,
            user_id: $user_id,
            preference_id: $preference_id
        ) {
            status
            message
            data
            messagecode
        }
    }
`;

const mutationChangeUserPassword = gql`
    mutation changeUserPassword ($newpassword: String!, $oldpassword: String!, $useremail: String! ) {
        changeUserPassword(newpassword: $newpassword, oldpassword: $oldpassword, useremail:$useremail) {
        status
        message
        data
        }
    }
`;

const mutationchangePassword = gql`
    mutation changePassword ($newpassword: String!, $oldpassword: String!, $useremail: String! ) {
        changePassword(newpassword: $newpassword, oldpassword: $oldpassword, useremail:$useremail) {
        status
        message
        data
        }
    }
`;


/*
billing_subscription_id: request.billing_subscription_id,
                          billing_customer_id: request.billing_customer_id,
                          billing_price_id: request.billing_price_id,
                          billing_product_id: request.billing_product_id,
                          billing_product_name: request.billing_product_name,
                          billing_member_qty: request.billing_member_qty,
                          prepaid: true,
                          adminemail: true
*/

const mutationSignupPrepaid = gql`
    mutation signup($middlename: String, 
                    $display: String, 
                    $customername: String, 
                    $lastname: String, 
                    $firstname: String, 
                    $username: String!, 
                    $rsc: String,
                    $billing_subscription_id: String,
                    $billing_customer_id: String,
                    $billing_price_id: String,
                    $billing_product_id: String,
                    $billing_product_name: String,
                    $prepaid: Boolean,
                    $adminemail: Boolean
                    ) {
        signup( middlename: $middlename, 
                display: $display, 
                customername: $customername, 
                lastname: $lastname, 
                firstname: $firstname, 
                username: $username,
                rsc: $rsc,
                billing_subscription_id: $billing_subscription_id,
                billing_customer_id: $billing_customer_id,
                billing_price_id: $billing_price_id,
                billing_product_id: $billing_product_id,
                billing_product_name: $billing_product_name,
                prepaid: $prepaid,
                adminemail: $adminemail
                ) {
            status
            message
            data
            messagecode
        }
    }
`;

const mutationSignup = gql`
    mutation signup($middlename: String, $display: String, $customername: String, $lastname: String, $firstname: String, $username: String!, $rsc: String) {
        signup(middlename: $middlename, display: $display, customername: $customername, lastname: $lastname, firstname: $firstname, username: $username,rsc:$rsc) {
            status
            message
            data
            messagecode
        }
    }
`;

const mutationConfirmUser = gql`
    mutation confirmUser ($email: String!) {
        confirmUser(email: $email) {
        status
        message
        data
        }
    }
`;

const mutationAddRole = gql`
    mutation addRole($rolename: String!, $rolealias: String, $roledesc: String, $schema: String!, $accesspages: JSON!) {
        addRole(rolename: $rolename, rolealias: $rolealias, roledesc: $roledesc, schemaname: $schema, accesspages: $accesspages ) {
            status
            message
            data
        }
    }
`;

const mutationDeleteRole = gql`
    mutation deleteRole($roleid: String!, $schema: String!) {
        deleteRole(roleid: $roleid, schemaname: $schema ) {
            status
            message
            data
            messagecode
        }
    }
`;

const mutationEditRole = gql`
    mutation editRole($roleid: String!, $rolename: String!, $rolealias: String, $roledesc: String, $schema: String!, $accesspages: JSON!) {
        editRole(roleid: $roleid, rolename: $rolename, rolealias: $rolealias, roledesc: $roledesc, schemaname: $schema, accesspages: $accesspages ) {
            status
            message
            data
        }
    }
`;

const mutationChangeRoleStatus = gql`
    mutation changeRoleStatus($roleid: String!, $active: Boolean!, $schema: String!) {
        changeRoleStatus( roleid: $roleid, active: $active, schemaname: $schema ) {
            status
            message
            data
            messagecode
        }
    }
`;

const mutationUpdateUserStatus = gql`
    mutation updateUserStatus($flag_value: Boolean!, $flag: String!,$customer_name: String!,$user_id: Float!) {
        updateUserStatus( flag_value: $flag_value, flag: $flag,customer_name: $customer_name,user_id: $user_id ) {
            status
            message
            messagecode
        }
    }
`;

const mutationChangeUserRoles = gql`
    mutation changeUserRoles($customer_name: String!, $role_id: String!, $user_id: String!) {
        changeUserRoles( customer_name: $customer_name, role_id: $role_id, user_id: $user_id ) {
            status
            message
            data
        }
    }
`;

const mutationResetUserPassword = gql`
    mutation resetUserPassword($password: String!, $email: String! ) {
        resetUserPassword( password: $password, email:$email) {
            status
            message
            data
        }
    }
`;

const mutationDeletePermanentUser = gql`
    mutation deletePermanentUser($username: String!, $customer_name: String!) {
        deletePermanentUser( username: $username, customer_name: $customer_name) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationEditUser = gql`
    mutation editUser($first_name: String!, $last_name: String!,$user_id: Float!) {
        editUser( first_name: $first_name, last_name: $last_name,user_id: $user_id ) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationUnlockUser = gql`
    mutation unlockUser($email: String!) {
        unlockUser( email: $email) {
            status
            messagecode
            message
            data
        }
    }
`;

const mutationgetStripeCustomerDetail = gql`
    mutation getStripeCustomerDetail($stripe_customer_id: String!) {
        getStripeCustomerDetail(stripe_customer_id: $stripe_customer_id) {
          status
          message
          data
        }
    }
`;

const mutationUserLock = gql`
    mutation userLock ($flag_value: Boolean!, $flag: String!,$customer_name: String!,$user_id: Float!) {
        userLock(flag_value: $flag_value, flag: $flag,customer_name: $customer_name,user_id: $user_id) {
          status
          message
          messagecode
        }
    }
`;

export {
  mutationUpdateMfa,
  mutationUploadProfilePicture,
  mutationAcceptDocument,
  mutationUpdateUserMetrics,
  mutationEditProfile,
  mutationUpdatePreference,
  mutationChangeUserPassword,
  mutationchangePassword,
  mutationSignup,
  mutationSignupPrepaid,
  mutationConfirmUser,
  mutationAddRole,
  mutationDeleteRole,
  mutationEditRole,
  mutationChangeRoleStatus,
  mutationUpdateUserStatus,
  mutationChangeUserRoles,
  mutationResetUserPassword,
  mutationDeletePermanentUser,
  mutationEditUser,
  mutationUnlockUser,
  mutationgetStripeCustomerDetail,
  mutationUserLock
};